<template>
  <search-select
    ref="select"
    :prop="prop"
    :api="api"
    :get-label="getLabel"
    :lazy-load="lazyLoad"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import SearchSelect from '@/components/select/search-select/search-select'
import http from '@plugin/axios'
export default {
  components: {
    SearchSelect
  },
  props: {
    // eslint-disable-next-line
    _select: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    lazyLoad() {
      return this._select._lazyLoad
    },
    prop() {
      const prop = this._select && this._select._value
      return prop || 'id'
    },
    api() {
      if (!this._select || !this._select._url) return () => Promise.resolve({})
      const data = typeof this._select._params === 'function' ? this._select._params.call(this, this.data) : this._select._params || {}
      return ({ keyword, current }) => http({
        url: this._select._url,
        baseURL: this._select._baseURL,
        data: {
          condition: {
            ...data,
            keyword
          },
          current,
          size: 10
        }
      })
    },
    getLabel() {
      const value = this._select && this._select._value
      const label = this._select && this._select._label
      if (!label) return option => option[value]
      if (typeof label === 'function') return label
      return option => option[label]
    }
  }
}
</script>
